export const Color = {
  purple: "#7903d4",
  gray: "#909090",
  black: "#515151",
};
